<h1>Testy parametrów zleceń </h1>
<form [formGroup]="form" (ngSubmit)="submit()">

  <!-- SYSTEMY -->
  <h3>Systemy</h3>
  <div formArrayName="systems">
    <label *ngFor="let s of systems; index as i">
      <input type="checkbox" [formControlName]="i" />
      {{ s }}
    </label>
  </div>

  <hr />

  <!-- DATY -->
  <h3>Zakres dat</h3>

  <label>
    <input type="checkbox" formControlName="dateFromEnabled" />
    Data od
    <input type="date" formControlName="dateFrom" />
  </label>

  <label>
    <input type="checkbox" formControlName="dateToEnabled" />
    Data do
    <input type="date" formControlName="dateTo" />
  </label>

  <hr />

  <!-- MAX ZLECEŃ -->
  <h3>
    <input type="checkbox" formControlName="maxOrdersEnabled" />
    Maksymalna liczba zleceń
  </h3>
  <input type="number" formControlName="maxOrders" />

  <hr />

  <!-- KEY VALUE -->
  <h3>
    <input type="checkbox" formControlName="keyValuesEnabled" />
    Parametry key=value
  </h3>

  <div formArrayName="keyValues" *ngIf="form.value.keyValuesEnabled">

    <div
      *ngFor="let kv of keyValues.controls; index as i"
      [formGroupName]="i"
      style="display: flex; gap: 8px; align-items: center; margin-bottom: 8px;"
    >
      <input type="text" formControlName="key" placeholder="key" />
      <input type="text" formControlName="value" placeholder="value" />

      <button type="button" (click)="removeKeyValue(i)">
        ✕
      </button>
    </div>

    <button type="button" (click)="addKeyValue()">+ Dodaj parametr</button>
    
  </div>

  <hr />

  <button type="submit">Zastosuj</button>
</form>
